export const columns = [
  {
    Header: 'Pregunta',
    accessor: 'question',
  },
  {
    Header: 'Respuesta',
    accessor: 'answer',
  },
  {
    Header: 'Imagen',
    accessor: 'image',
  },
  {
    Header: 'Editar',
    accessor: 'editQuestions',
  },
  {
    Header: 'Eliminar',
    accessor: 'deleteQuestions',
  },
  {
    Header: 'Estado',
    accessor: 'active',
  },
]

export const data = [
  {
    title: 'Titulo 1',
    content: 'Contenido 1',
    image: 'https://via.placeholder.com/150',
    link: 'https://via.placeholder.com/150',
  },
  {
    title: 'Titulo 2',
    content: 'Contenido 2',
    image: 'https://via.placeholder.com/150',
    link: 'https://via.placeholder.com/150',
  },
  {
    title: 'Titulo 3',
    content: 'Contenido 3',
    image: 'https://via.placeholder.com/150',
    link: 'https://via.placeholder.com/150',
  },
]
